export const age18 = '18+';
